import { AppBreadcrumb } from '@coreui/react'
import { subscribe } from 'libs/mqtt-react'
import React from 'react'
import { Container } from 'reactstrap'
import { mqttHandlers } from 'redux/actions/mqtt'
import { Redirect, Switch, Route } from 'react-router-dom'
import PropTypes from 'prop-types'

const Outlet = ({ routes, ...props }) => {
  return (
    <main className="main">
      <AppBreadcrumb className="ml-auto" appRoutes={routes} />
      <Container
        fluid
        className={props.location?.pathname === '/dashboard' ? 'h-88' : ''}
      >
        <Switch>
          {routes.map((route, idx) => {
            return route.component ? (
              <Route
                key={idx}
                path={route.path}
                exact={route.exact}
                name={route.name}
                render={(props) => <route.component {...props} />}
              />
            ) : null
          })}
          <Redirect from="/" to="/dashboard" />
        </Switch>
      </Container>
    </main>
  )
}

Outlet.propTypes = {
  routes: PropTypes.any,
  location: PropTypes.any,
}

export default subscribe({
  topic: '#',
  dispatch: mqttHandlers,
})(Outlet)
